/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Kpi_Eu_Share_BadgeInputs */



/**
* | output |
* | --- |
* | "Share of all tokens" |
*
* @param {Dashboard_Kpi_Eu_Share_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_kpi_eu_share_badge = /** @type {((inputs?: Dashboard_Kpi_Eu_Share_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Kpi_Eu_Share_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anteil aller Token")
	return /** @type {LocalizedString} */ ("Share of all tokens")
});